import _ from 'lodash';

export const filterInventoryByStatus = (inventory, status) => _.filter(inventory, { 'status': status });